<template>
  <div class="pipeline-view">
    <div v-if="totalJobs === 0" class="pipeline-empty">
      <i class="fas fa-chart-line"></i>
      <p>Save jobs from the extension or web to see your pipeline here.</p>
    </div>

    <template v-else>
      <div class="sankey-wrap">
        <VChart
          class="sankey-chart"
          :option="chartOption"
          autoresize
        />
      </div>

      <div class="sankey-legend">
        <span class="legend-item"><span class="swatch progress"></span> Forward progress</span>
        <span class="legend-item"><span class="swatch negative"></span> Passed / closed</span>
      </div>

      <p class="pipeline-hint">
        Band width shows how many jobs reached each stage. Update status on the <strong>Jobs</strong> tab as you go.
      </p>
    </template>
  </div>
</template>

<script>
import { use } from 'echarts/core';
import { SankeyChart } from 'echarts/charts';
import { TooltipComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import VChart from 'vue-echarts';
import { mapGetters } from 'vuex';
import { buildPipelineSankeyOption } from '@/utils/pipelineSankey';

use([CanvasRenderer, SankeyChart, TooltipComponent]);

export default {
  name: 'ApplicationPipeline',
  components: { VChart },
  props: {
    /** Precomputed pipeline buckets from GET /api/jobs/stats */
    buckets: {
      type: Object,
      default: () => ({
        saved: 0,
        ready: 0,
        applied: 0,
        interviewing: 0,
        offer: 0,
        passed: 0,
        skipped: 0,
      }),
    },
    total: { type: Number, default: 0 },
  },
  computed: {
    ...mapGetters('theme', ['isDark']),
    totalJobs() {
      return this.total;
    },
    chartOption() {
      return buildPipelineSankeyOption(this.buckets, { isDark: this.isDark });
    },
  },
};
</script>

<style scoped>
.pipeline-view {
  width: 100%;
}

.pipeline-empty {
  text-align: center;
  padding: 48px 24px;
  color: var(--text-muted);
}

.pipeline-empty i {
  font-size: 32px;
  margin-bottom: 12px;
  opacity: 0.5;
}

.sankey-wrap {
  width: 100%;
  min-height: 360px;
}

.sankey-chart {
  width: 100%;
  height: 360px;
  min-height: 320px;
}

.sankey-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  margin-bottom: 16px;
  font-size: 13px;
  color: var(--text-secondary);
}

.legend-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.swatch {
  width: 28px;
  height: 10px;
  border-radius: 3px;
}

.swatch.progress {
  background: #22c55e;
  opacity: 0.75;
}

.swatch.negative {
  background: #f87171;
  opacity: 0.7;
}

.pipeline-hint {
  margin: 0;
  font-size: 13px;
  color: var(--text-secondary);
  text-align: left;
}

@media (max-width: 768px) {
  .sankey-wrap,
  .sankey-chart {
    min-height: 300px;
    height: 300px;
  }

  .pipeline-view {
    padding-bottom: 8px;
  }

  .sankey-legend {
    justify-content: flex-start;
  }
}
</style>
